import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=e1f0da6c&scoped=true&"
import script from "./Pagination.vue?vue&type=script&lang=js&"
export * from "./Pagination.vue?vue&type=script&lang=js&"
import style0 from "./Pagination.vue?vue&type=style&index=0&id=e1f0da6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1f0da6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev/tafelgasten.outlawz.dev/web/app/themes/tafelgasten/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1f0da6c')) {
      api.createRecord('e1f0da6c', component.options)
    } else {
      api.reload('e1f0da6c', component.options)
    }
    module.hot.accept("./Pagination.vue?vue&type=template&id=e1f0da6c&scoped=true&", function () {
      api.rerender('e1f0da6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/Checkout/Components/Common/Pagination.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/Checkout/Components/Common/Pagination.vue
// module id = 269
// module chunks = 0